var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPsychiatristIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 70,
    viewBox: "0 0 71 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 70.373,
    height: 70,
    rx: 35,
    fill: "#E8FAFE"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_502_5242)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.0874 28.7954C54.9682 29.8071 55.4297 31.1167 55.3777 32.457C55.3257 33.7973 54.7642 35.0673 53.8078 36.0077C52.8513 36.9481 51.572 37.488 50.231 37.5173C48.89 37.5466 47.5884 37.0631 46.5918 36.1654L54.0874 28.7954Z",
    fill: "#01B5E6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.0185 30.8902C45.2478 30.0362 45.6883 29.2535 46.2995 28.6145C46.9107 27.9754 47.6729 27.5005 48.5159 27.2334C49.3589 26.9663 50.2555 26.9157 51.1232 27.0862C51.9909 27.2567 52.8017 27.6428 53.4809 28.209L46.0046 35.5468C45.4866 34.9023 45.1275 34.145 44.9562 33.3361C44.7849 32.5272 44.8062 31.6893 45.0185 30.8902Z",
    fill: "#01B5E6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.2006 46.3585C40.4299 45.5044 40.8704 44.7218 41.4816 44.0827C42.0928 43.4437 42.855 42.9687 43.698 42.7016C44.5409 42.4346 45.4376 42.3839 46.3053 42.5544C47.173 42.7249 47.9838 43.1111 48.663 43.6773L41.1899 51.0247C40.669 50.3799 40.3078 49.6211 40.1358 48.8102C39.9639 47.9993 39.9861 47.1592 40.2006 46.3585Z",
    fill: "#01B5E6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.2892 21.8475C33.6494 20.5193 34.5207 19.3877 35.7126 18.7C36.9046 18.0122 38.3203 17.8242 39.6505 18.177C40.9787 18.5372 42.1103 19.4085 42.798 20.6005C43.4858 21.7924 43.6738 23.2082 43.321 24.5383C42.5089 27.574 41.7097 30.5935 40.8783 33.6162L36.2249 32.3691V30.4549C36.2229 29.6512 35.9032 28.8809 35.3355 28.3119C34.7638 27.7397 33.9885 27.4175 33.1796 27.416H31.8262C32.316 25.5728 32.809 23.7241 33.3053 21.8701L33.2892 21.8475Z",
    fill: "#D92D27"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.7723 19.3955C35.4543 18.7623 36.2932 18.3228 37.2021 18.1226L34.3952 27.6677C34.0076 27.4956 33.5883 27.4067 33.1642 27.4067H31.8301L33.5831 21.4708C33.8107 20.6989 34.2183 19.9921 34.7723 19.4084V19.3955Z",
    fill: "#DE5149"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.9826 34.9506C39.2629 37.6146 38.5475 40.2743 37.8364 42.9297C37.4777 44.2517 36.6104 45.3781 35.4239 46.0628C34.2374 46.7475 32.8282 46.9349 31.5041 46.584C30.6663 46.3551 29.8994 45.9194 29.2738 45.3169C28.6483 44.7145 28.1841 43.9645 27.9238 43.1359C28.3108 42.981 28.6626 42.7498 28.9583 42.4559C29.2426 42.1727 29.4683 41.8363 29.6226 41.4658C29.7769 41.0954 29.8566 40.6981 29.8574 40.2968V36.9937H33.1637C33.5672 36.9953 33.9671 36.9166 34.3399 36.7622C34.7128 36.6079 35.0513 36.3809 35.3357 36.0946C35.9054 35.5263 36.2284 34.7564 36.2348 33.9517L39.9826 34.9506Z",
    fill: "#FCCB64"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.0742 43.0746C28.4003 42.9238 28.697 42.7165 28.9507 42.4623C29.237 42.1789 29.4644 41.8416 29.6198 41.47C29.7752 41.0983 29.8556 40.6996 29.8563 40.2968V36.9937H31.6448L29.2408 45.1596C28.6912 44.5676 28.2912 43.8527 28.0742 43.0746Z",
    fill: "#FCD582"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.2704 44.2861C50.1407 45.2987 50.5938 46.604 50.538 47.9379C50.4823 49.2719 49.922 50.5349 48.9704 51.4714C48.0188 52.4078 46.7469 52.9478 45.4123 52.9821C44.0776 53.0164 42.7797 52.5424 41.7812 51.6561L49.2769 44.2861H49.2704Z",
    fill: "#01B5E6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.2733 23.1333H26.8438C27.1655 23.135 27.4736 23.2635 27.701 23.491C27.9285 23.7185 28.057 24.0265 28.0587 24.3482V29.182H32.8926C33.2139 29.1829 33.522 29.3107 33.7495 29.5376C33.9771 29.7646 34.1057 30.0723 34.1074 30.3937V33.9771C34.1058 34.2988 33.9772 34.6069 33.7497 34.8343C33.5223 35.0618 33.2142 35.1903 32.8926 35.192H28.0587V40.0259C28.057 40.3475 27.9285 40.6556 27.701 40.883C27.4736 41.1105 27.1655 41.2391 26.8438 41.2408H23.2733C22.9516 41.2391 22.6436 41.1105 22.4161 40.883C22.1886 40.6556 22.0601 40.3475 22.0584 40.0259V35.192H17.2246C16.9012 35.1929 16.5907 35.0655 16.3611 34.8377C16.1316 34.61 16.0017 34.3005 16 33.9771V30.4066C16.0017 30.0849 16.1302 29.7769 16.3577 29.5494C16.5852 29.3219 16.8932 29.1934 17.2149 29.1917H22.0487V24.3579C22.0496 24.0365 22.1774 23.7284 22.4043 23.5009C22.6313 23.2733 22.939 23.1447 23.2604 23.143L23.2733 23.1333Z",
    fill: "#D92D27"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_502_5242"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 39.373,
    height: 35,
    fill: "white",
    transform: "translate(16 18)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPsychiatristIcon);
export default __webpack_public_path__ + "static/media/psychiatrist-icon.022e46e30bc7786f1d03434f46f67f35.svg";
export { ForwardRef as ReactComponent };